module.exports = __webpack_public_path__ + "img/Margarite.230b056.png";